import React from "react";
import clsx from "clsx";
import MeasurementItem from "../Common/MeasurementItem";

const CIDBox = ({ className, sourceData, deltaSourceData = {} }) => {
	const { weight, smm, bfm, weightPercentage, smmPercentage, bfmPercentage } = sourceData;
	const { deltaWeight, deltaSMM, deltaBFM } = deltaSourceData;
	
	return (
		<div className={clsx(className)}>
			<MeasurementItem 
				name="體重" 
				value={weight} 
				unit="kg" 
				percentage={weightPercentage} 
				normalRange={[85, 115]} 
				minValue={40} 
				maxValue={220} 
				deltaValue={deltaWeight} 
			/>
			<MeasurementItem 
				name="骨骼肌重" 
				value={smm} 
				unit="kg" 
				percentage={smmPercentage} 
				normalRange={[90, 110]} 
				minValue={60} 
				maxValue={180} 
				deltaValue={deltaSMM} 
			/>
			<MeasurementItem 
				name="體脂肪重" 
				value={bfm} 
				unit="kg" 
				percentage={bfmPercentage} 
				normalRange={[80, 160]} 
				minValue={20} 
				maxValue={580} 
				deltaValue={deltaBFM} 
			/>
		</div>
	);
};

export default CIDBox;
